import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, a as assertParamExists, C as COLLECTION_FORMATS, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ProductsApi - axios parameter creator
 * @export
 */
const ProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [Price]
         * @param {number} [DiscountRate]
         * @param {number} [DiscountValue]
         * @param {boolean} [Visible]
         * @param {boolean} [Used]
         * @param {boolean} [Featured]
         * @param {boolean} [Skroutz]
         * @param {boolean} [BestPrice]
         * @param {boolean} [Linkwise]
         * @param {boolean} [Social]
         * @param {number} [Availability]
         * @param {string} [CategoriesToAdd]
         * @param {string} [CategoriesToRemove]
         * @param {string} [ProductStatusesToAdd]
         * @param {string} [ProductStatusesToRemove]
         * @param {string} [VideoToAdd]
         * @param {string} [VideoToRemove]
         * @param {string} [NewsentryToAdd]
         * @param {string} [NewsentryToRemove]
         * @param {string} [EventsToAdd]
         * @param {string} [EventsToRemove]
         * @param {Array<number>} [CategoriesToAddList]
         * @param {Array<number>} [CategoriesToRemoveList]
         * @param {Array<number>} [ProductStatusesToAddList]
         * @param {Array<number>} [ProductStatusesToRemoveList]
         * @param {Array<number>} [VideoToAddList]
         * @param {Array<number>} [VideoToRemoveList]
         * @param {Array<number>} [NewsentryToAddList]
         * @param {Array<number>} [NewsentryToRemoveList]
         * @param {Array<number>} [EventsToAddList]
         * @param {Array<number>} [EventsToRemoveList]
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [productIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkEdit: async (Price, DiscountRate, DiscountValue, Visible, Used, Featured, Skroutz, BestPrice, Linkwise, Social, Availability, CategoriesToAdd, CategoriesToRemove, ProductStatusesToAdd, ProductStatusesToRemove, VideoToAdd, VideoToRemove, NewsentryToAdd, NewsentryToRemove, EventsToAdd, EventsToRemove, CategoriesToAddList, CategoriesToRemoveList, ProductStatusesToAddList, ProductStatusesToRemoveList, VideoToAddList, VideoToRemoveList, NewsentryToAddList, NewsentryToRemoveList, EventsToAddList, EventsToRemoveList, loadOptions, productIds, options = {}) => {
            const localVarPath = `/v1/Products/BulkEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Price !== undefined) {
                localVarQueryParameter['Price'] = Price;
            }
            if (DiscountRate !== undefined) {
                localVarQueryParameter['DiscountRate'] = DiscountRate;
            }
            if (DiscountValue !== undefined) {
                localVarQueryParameter['DiscountValue'] = DiscountValue;
            }
            if (Visible !== undefined) {
                localVarQueryParameter['Visible'] = Visible;
            }
            if (Used !== undefined) {
                localVarQueryParameter['Used'] = Used;
            }
            if (Featured !== undefined) {
                localVarQueryParameter['Featured'] = Featured;
            }
            if (Skroutz !== undefined) {
                localVarQueryParameter['Skroutz'] = Skroutz;
            }
            if (BestPrice !== undefined) {
                localVarQueryParameter['BestPrice'] = BestPrice;
            }
            if (Linkwise !== undefined) {
                localVarQueryParameter['Linkwise'] = Linkwise;
            }
            if (Social !== undefined) {
                localVarQueryParameter['Social'] = Social;
            }
            if (Availability !== undefined) {
                localVarQueryParameter['Availability'] = Availability;
            }
            if (CategoriesToAdd !== undefined) {
                localVarQueryParameter['CategoriesToAdd'] = CategoriesToAdd;
            }
            if (CategoriesToRemove !== undefined) {
                localVarQueryParameter['CategoriesToRemove'] = CategoriesToRemove;
            }
            if (ProductStatusesToAdd !== undefined) {
                localVarQueryParameter['ProductStatusesToAdd'] = ProductStatusesToAdd;
            }
            if (ProductStatusesToRemove !== undefined) {
                localVarQueryParameter['ProductStatusesToRemove'] = ProductStatusesToRemove;
            }
            if (VideoToAdd !== undefined) {
                localVarQueryParameter['VideoToAdd'] = VideoToAdd;
            }
            if (VideoToRemove !== undefined) {
                localVarQueryParameter['VideoToRemove'] = VideoToRemove;
            }
            if (NewsentryToAdd !== undefined) {
                localVarQueryParameter['NewsentryToAdd'] = NewsentryToAdd;
            }
            if (NewsentryToRemove !== undefined) {
                localVarQueryParameter['NewsentryToRemove'] = NewsentryToRemove;
            }
            if (EventsToAdd !== undefined) {
                localVarQueryParameter['EventsToAdd'] = EventsToAdd;
            }
            if (EventsToRemove !== undefined) {
                localVarQueryParameter['EventsToRemove'] = EventsToRemove;
            }
            if (CategoriesToAddList) {
                localVarQueryParameter['CategoriesToAddList'] = CategoriesToAddList;
            }
            if (CategoriesToRemoveList) {
                localVarQueryParameter['CategoriesToRemoveList'] = CategoriesToRemoveList;
            }
            if (ProductStatusesToAddList) {
                localVarQueryParameter['ProductStatusesToAddList'] = ProductStatusesToAddList;
            }
            if (ProductStatusesToRemoveList) {
                localVarQueryParameter['ProductStatusesToRemoveList'] = ProductStatusesToRemoveList;
            }
            if (VideoToAddList) {
                localVarQueryParameter['VideoToAddList'] = VideoToAddList;
            }
            if (VideoToRemoveList) {
                localVarQueryParameter['VideoToRemoveList'] = VideoToRemoveList;
            }
            if (NewsentryToAddList) {
                localVarQueryParameter['NewsentryToAddList'] = NewsentryToAddList;
            }
            if (NewsentryToRemoveList) {
                localVarQueryParameter['NewsentryToRemoveList'] = NewsentryToRemoveList;
            }
            if (EventsToAddList) {
                localVarQueryParameter['EventsToAddList'] = EventsToAddList;
            }
            if (EventsToRemoveList) {
                localVarQueryParameter['EventsToRemoveList'] = EventsToRemoveList;
            }
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (productIds !== undefined) {
                localVarQueryParameter['productIds'] = productIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {BulkEditTokenPost} [BulkEditTokenPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkEditPost: async (BulkEditTokenPost, options = {}) => {
            const localVarPath = `/v1/Products/BulkEditPost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BulkEditTokenPost, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categories: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('categories', 'id', id);
            const localVarPath = `/v1/Products/Categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductAward: async (id, options = {}) => {
            const localVarPath = `/v1/Products/DeleteProductAward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary BW-8338 N4: the signed-in customer\'s catalogue as an Excel workbook, with their wholesale prices and the configured suggested-retail prices. 404 unless `CatalogExport:Enabled`, and 404 when the session resolves to no customer (e.g. the token of a removed employee) rather than exporting the anonymous catalogue. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCatalog: async (options = {}) => {
            const localVarPath = `/v1/Products/ExportCatalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductTokenList} [ProductTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceERPSync: async (ProductTokenList, options = {}) => {
            const localVarPath = `/v1/Products/ForceERPSync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductTokenList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/Products/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,OrderApproval,Erp)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [q]
         * @param {boolean} [searchVisible]
         * @param {string} [cids]
         * @param {boolean} [includeSubcategories]
         * @param {boolean} [includeMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGrid: async (loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options = {}) => {
            const localVarPath = `/v1/Products/GetAllGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (searchVisible !== undefined) {
                localVarQueryParameter['searchVisible'] = searchVisible;
            }
            if (cids !== undefined) {
                localVarQueryParameter['cids'] = cids;
            }
            if (includeSubcategories !== undefined) {
                localVarQueryParameter['includeSubcategories'] = includeSubcategories;
            }
            if (includeMetadata !== undefined) {
                localVarQueryParameter['includeMetadata'] = includeMetadata;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin-v2 products grid. Same shape/response as M:BizWeb.NC.API.Controllers.ProductsController.GetAllGrid(BizWeb.NC.API.DataSourceLoadOptions,BizWeb.NC.API.Services.IFileProcessor,System.String,System.Boolean,System.String,System.Boolean,System.Boolean), but applies server-side column sorting and free-text search to the SQL projection via an explicit allowlist. Kept as a separate endpoint so the legacy admin\'s GetAllGrid is left unchanged. (Auth roles: Catalog,OrderApproval,Erp)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [q]
         * @param {boolean} [searchVisible]
         * @param {string} [cids]
         * @param {boolean} [includeSubcategories]
         * @param {boolean} [includeMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGridV2: async (loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options = {}) => {
            const localVarPath = `/v1/Products/GetAllGridV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (searchVisible !== undefined) {
                localVarQueryParameter['searchVisible'] = searchVisible;
            }
            if (cids !== undefined) {
                localVarQueryParameter['cids'] = cids;
            }
            if (includeSubcategories !== undefined) {
                localVarQueryParameter['includeSubcategories'] = includeSubcategories;
            }
            if (includeMetadata !== undefined) {
                localVarQueryParameter['includeMetadata'] = includeMetadata;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductAwardsById: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetAllProductAwardsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubTypes: async (options = {}) => {
            const localVarPath = `/v1/Products/GetAllSubTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilityStatuses: async (options = {}) => {
            const localVarPath = `/v1/Products/GetAvailabilityStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailable: async (q, sort, page, psize, options = {}) => {
            const localVarPath = `/v1/Products/GetAvailable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [days]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestSellers: async (days, options = {}) => {
            const localVarPath = `/v1/Products/GetBestSellers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [eagercache]
         * @param {boolean} [prefilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCategoryId: async (id, q, sort, page, psize, eagercache, prefilter, options = {}) => {
            const localVarPath = `/v1/Products/GetByCategoryId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            if (eagercache !== undefined) {
                localVarQueryParameter['eagercache'] = eagercache;
            }
            if (prefilter !== undefined) {
                localVarQueryParameter['prefilter'] = prefilter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCode: async (code, options = {}) => {
            const localVarPath = `/v1/Products/GetByCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [customerId]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerRecommendations: async (customerId, q, sort, page, psize, options = {}) => {
            const localVarPath = `/v1/Products/GetByCustomerRecommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdEnriched: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetByIdEnriched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdFront: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetByIdFront`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, enrich, options = {}) => {
            const localVarPath = `/v1/Products/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (enrich !== undefined) {
                localVarQueryParameter['enrich'] = enrich;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdsAdmin: async (request_body, enrich, options = {}) => {
            const localVarPath = `/v1/Products/GetByIdsAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (enrich !== undefined) {
                localVarQueryParameter['enrich'] = enrich;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByManufacturerId: async (id, q, sort, page, psize, options = {}) => {
            const localVarPath = `/v1/Products/GetByManufacturerId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [productsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByProductsIds: async (productsIds, options = {}) => {
            const localVarPath = `/v1/Products/GetByProductsIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (productsIds !== undefined) {
                localVarQueryParameter['productsIds'] = productsIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [participatingProducts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPromotionPolicyId: async (id, q, sort, page, psize, participatingProducts, options = {}) => {
            const localVarPath = `/v1/Products/GetByPromotionPolicyId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            if (participatingProducts !== undefined) {
                localVarQueryParameter['participatingProducts'] = participatingProducts;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUrl: async (url, options = {}) => {
            const localVarPath = `/v1/Products/GetByUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [productId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryTree: async (productId, options = {}) => {
            const localVarPath = `/v1/Products/GetCategoryTree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [codes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributorProducts: async (id, sort, page, psize, codes, options = {}) => {
            const localVarPath = `/v1/Products/GetContributorProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            if (codes !== undefined) {
                localVarQueryParameter['codes'] = codes;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscounted: async (q, sort, page, psize, options = {}) => {
            const localVarPath = `/v1/Products/GetDiscounted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedProducts: async (sort, page, psize, options = {}) => {
            const localVarPath = `/v1/Products/GetFeaturedProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedProductsByCategoryId: async (id, q, sort, page, psize, options = {}) => {
            const localVarPath = `/v1/Products/GetFeaturedProductsByCategoryId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [statusId]
         * @param {string} [q]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltersByCategoryAndStatusId: async (id, statusId, q, options = {}) => {
            const localVarPath = `/v1/Products/GetFiltersByCategoryAndStatusId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (statusId !== undefined) {
                localVarQueryParameter['statusId'] = statusId;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [oid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFromSavedOrder: async (oid, options = {}) => {
            const localVarPath = `/v1/Products/GetFromSavedOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (oid !== undefined) {
                localVarQueryParameter['oid'] = oid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCards: async (options = {}) => {
            const localVarPath = `/v1/Products/GetGiftCards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The products sharing the product\'s GroupCode, without the product itself: admin-v2 copies an editorial review onto them (BW-3930). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupedProducts: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetGroupedProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewest: async (q, sort, page, psize, options = {}) => {
            const localVarPath = `/v1/Products/GetNewest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerEntity: async (entityId, entity, options = {}) => {
            const localVarPath = `/v1/Products/GetPerEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {number} [numberOfItems]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalisedProductsByCategory: async (categoryId, numberOfItems, options = {}) => {
            const localVarPath = `/v1/Products/GetPersonalisedProductsByCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (numberOfItems !== undefined) {
                localVarQueryParameter['numberOfItems'] = numberOfItems;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [pdid]
         * @param {number} [tid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceHistory: async (id, pdid, tid, options = {}) => {
            const localVarPath = `/v1/Products/GetPriceHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (pdid !== undefined) {
                localVarQueryParameter['pdid'] = pdid;
            }
            if (tid !== undefined) {
                localVarQueryParameter['tid'] = tid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBundleById: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetProductBundleById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary All bundles containing the product that are active for the current customer, with enriched children and totals
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBundles: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetProductBundles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [price]
         * @param {string} [priceBD]
         * @param {string} [discount]
         * @param {number} [dimensionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductLoyaltyPoints: async (id, price, priceBD, discount, dimensionId, options = {}) => {
            const localVarPath = `/v1/Products/GetProductLoyaltyPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (price !== undefined) {
                localVarQueryParameter['price'] = price;
            }
            if (priceBD !== undefined) {
                localVarQueryParameter['priceBD'] = priceBD;
            }
            if (discount !== undefined) {
                localVarQueryParameter['discount'] = discount;
            }
            if (dimensionId !== undefined) {
                localVarQueryParameter['dimensionId'] = dimensionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {string} [price]
         * @param {string} [priceBD]
         * @param {string} [discount]
         * @param {number} [cid]
         * @param {number} [dimensionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductLoyaltyPointsAdmin: async (id, price, priceBD, discount, cid, dimensionId, options = {}) => {
            const localVarPath = `/v1/Products/GetProductLoyaltyPointsAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (price !== undefined) {
                localVarQueryParameter['price'] = price;
            }
            if (priceBD !== undefined) {
                localVarQueryParameter['priceBD'] = priceBD;
            }
            if (discount !== undefined) {
                localVarQueryParameter['discount'] = discount;
            }
            if (cid !== undefined) {
                localVarQueryParameter['cid'] = cid;
            }
            if (dimensionId !== undefined) {
                localVarQueryParameter['dimensionId'] = dimensionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStock: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetProductStock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductType: async (options = {}) => {
            const localVarPath = `/v1/Products/GetProductType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarehouses: async (code, options = {}) => {
            const localVarPath = `/v1/Products/GetProductWarehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsAwardsById: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetProductsAwardsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByEventId: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetProductsByEventId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByTopCustomerRecommendations: async (options = {}) => {
            const localVarPath = `/v1/Products/GetProductsByTopCustomerRecommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [productId]
         * @param {string} [code]
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedInfoAndProductsByCode: async (productId, code, categoryId, options = {}) => {
            const localVarPath = `/v1/Products/GetRelatedInfoAndProductsByCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [productId]
         * @param {string} [code]
         * @param {number} [categoryId]
         * @param {Set<number>} [productCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedProductsByCode: async (productId, code, categoryId, productCategoryIds, options = {}) => {
            const localVarPath = `/v1/Products/GetRelatedProductsByCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (productCategoryIds) {
                localVarQueryParameter['productCategoryIds'] = Array.from(productCategoryIds);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [productId]
         * @param {number} [relationTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedProductsByProductId: async (productId, relationTypeId, options = {}) => {
            const localVarPath = `/v1/Products/GetRelatedProductsByProductId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }
            if (relationTypeId !== undefined) {
                localVarQueryParameter['relationTypeId'] = relationTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchTerms: async (options = {}) => {
            const localVarPath = `/v1/Products/GetSearchTerms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleLookup: async (options = {}) => {
            const localVarPath = `/v1/Products/GetSimpleLookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizesByCategoryId: async (id, options = {}) => {
            const localVarPath = `/v1/Products/GetSizesByCategoryId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Per-status product counts for the grid saved-filter chips. Definitions mirror the legacy admin product filters (out-of-stock = grid Quantity <= 0; hidden = !IsVisible; featured; no-image = hasImage No; new-releases = ReleaseDate within the recent window). Reads over existing columns — no schema change. \"Pending ERP sync\" is omitted (no legacy definition). (Auth roles: Catalog, OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusCounts: async (options = {}) => {
            const localVarPath = `/v1/Products/GetStatusCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ProductToken} [ProductToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ProductToken, options = {}) => {
            const localVarPath = `/v1/Products/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertProductAward: async (AwardToken, options = {}) => {
            const localVarPath = `/v1/Products/InsertProductAward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(AwardToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns a list of products based on the provided filters. (Auth roles: Catalog, OrderApproval)
         * @param {ProductLookupRequest} ProductLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (ProductLookupRequest, X_Lookup_Metadata, options = {}) => {
            // verify required parameter 'ProductLookupRequest' is not null or undefined
            assertParamExists('lookup', 'ProductLookupRequest', ProductLookupRequest);
            const localVarPath = `/v1/Products/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (X_Lookup_Metadata) {
                let mapped = X_Lookup_Metadata.map(value => (value || ""));
                localVarHeaderParameter['X-Lookup-Metadata'] = mapped.join(COLLECTION_FORMATS["csv"]);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductLookupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {PrerenderRecacheRequest} [PrerenderRecacheRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prerenderRecache: async (PrerenderRecacheRequest, options = {}) => {
            const localVarPath = `/v1/Products/PrerenderRecache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PrerenderRecacheRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Products/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [productId]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePerEntity: async (productId, entityId, entity, options = {}) => {
            const localVarPath = `/v1/Products/RemovePerEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (q, page, psize, options = {}) => {
            const localVarPath = `/v1/Products/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [key]
         * @param {string} [cids]
         * @param {string} [stids]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [prefilter]
         * @param {string} [code]
         * @param {string} [barcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWithFilters: async (key, cids, stids, q, sort, page, psize, prefilter, code, barcode, options = {}) => {
            const localVarPath = `/v1/Products/SearchWithFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (cids !== undefined) {
                localVarQueryParameter['cids'] = cids;
            }
            if (stids !== undefined) {
                localVarQueryParameter['stids'] = stids;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            if (prefilter !== undefined) {
                localVarQueryParameter['prefilter'] = prefilter;
            }
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιστρέφει λίστα από διαθέσιμα product ids
         * @param {Array<number>} request_body Τα product ids που θέλουμε να δούμε αν είναι ορατά στο front
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trimProductIds: async (request_body, options = {}) => {
            // verify required parameter 'request_body' is not null or undefined
            assertParamExists('trimProductIds', 'request_body', request_body);
            const localVarPath = `/v1/Products/TrimProductIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ProductToken} [ProductToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ProductToken, options = {}) => {
            const localVarPath = `/v1/Products/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [productId]
         * @param {number} [sortIndex]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerEntity: async (productId, sortIndex, entityId, entity, options = {}) => {
            const localVarPath = `/v1/Products/UpdatePerEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }
            if (sortIndex !== undefined) {
                localVarQueryParameter['sortIndex'] = sortIndex;
            }
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductAward: async (AwardToken, options = {}) => {
            const localVarPath = `/v1/Products/UpdateProductAward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(AwardToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductsApi - functional programming interface
 * @export
 */
const ProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [Price]
         * @param {number} [DiscountRate]
         * @param {number} [DiscountValue]
         * @param {boolean} [Visible]
         * @param {boolean} [Used]
         * @param {boolean} [Featured]
         * @param {boolean} [Skroutz]
         * @param {boolean} [BestPrice]
         * @param {boolean} [Linkwise]
         * @param {boolean} [Social]
         * @param {number} [Availability]
         * @param {string} [CategoriesToAdd]
         * @param {string} [CategoriesToRemove]
         * @param {string} [ProductStatusesToAdd]
         * @param {string} [ProductStatusesToRemove]
         * @param {string} [VideoToAdd]
         * @param {string} [VideoToRemove]
         * @param {string} [NewsentryToAdd]
         * @param {string} [NewsentryToRemove]
         * @param {string} [EventsToAdd]
         * @param {string} [EventsToRemove]
         * @param {Array<number>} [CategoriesToAddList]
         * @param {Array<number>} [CategoriesToRemoveList]
         * @param {Array<number>} [ProductStatusesToAddList]
         * @param {Array<number>} [ProductStatusesToRemoveList]
         * @param {Array<number>} [VideoToAddList]
         * @param {Array<number>} [VideoToRemoveList]
         * @param {Array<number>} [NewsentryToAddList]
         * @param {Array<number>} [NewsentryToRemoveList]
         * @param {Array<number>} [EventsToAddList]
         * @param {Array<number>} [EventsToRemoveList]
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [productIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkEdit(Price, DiscountRate, DiscountValue, Visible, Used, Featured, Skroutz, BestPrice, Linkwise, Social, Availability, CategoriesToAdd, CategoriesToRemove, ProductStatusesToAdd, ProductStatusesToRemove, VideoToAdd, VideoToRemove, NewsentryToAdd, NewsentryToRemove, EventsToAdd, EventsToRemove, CategoriesToAddList, CategoriesToRemoveList, ProductStatusesToAddList, ProductStatusesToRemoveList, VideoToAddList, VideoToRemoveList, NewsentryToAddList, NewsentryToRemoveList, EventsToAddList, EventsToRemoveList, loadOptions, productIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkEdit(Price, DiscountRate, DiscountValue, Visible, Used, Featured, Skroutz, BestPrice, Linkwise, Social, Availability, CategoriesToAdd, CategoriesToRemove, ProductStatusesToAdd, ProductStatusesToRemove, VideoToAdd, VideoToRemove, NewsentryToAdd, NewsentryToRemove, EventsToAdd, EventsToRemove, CategoriesToAddList, CategoriesToRemoveList, ProductStatusesToAddList, ProductStatusesToRemoveList, VideoToAddList, VideoToRemoveList, NewsentryToAddList, NewsentryToRemoveList, EventsToAddList, EventsToRemoveList, loadOptions, productIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.bulkEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {BulkEditTokenPost} [BulkEditTokenPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkEditPost(BulkEditTokenPost, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkEditPost(BulkEditTokenPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.bulkEditPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categories(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categories(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.categories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductAward(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductAward(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.deleteProductAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary BW-8338 N4: the signed-in customer\'s catalogue as an Excel workbook, with their wholesale prices and the configured suggested-retail prices. 404 unless `CatalogExport:Enabled`, and 404 when the session resolves to no customer (e.g. the token of a removed employee) rather than exporting the anonymous catalogue. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCatalog(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCatalog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.exportCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductTokenList} [ProductTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forceERPSync(ProductTokenList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forceERPSync(ProductTokenList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.forceERPSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,OrderApproval,Erp)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [q]
         * @param {boolean} [searchVisible]
         * @param {string} [cids]
         * @param {boolean} [includeSubcategories]
         * @param {boolean} [includeMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGrid(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGrid(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAllGrid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin-v2 products grid. Same shape/response as M:BizWeb.NC.API.Controllers.ProductsController.GetAllGrid(BizWeb.NC.API.DataSourceLoadOptions,BizWeb.NC.API.Services.IFileProcessor,System.String,System.Boolean,System.String,System.Boolean,System.Boolean), but applies server-side column sorting and free-text search to the SQL projection via an explicit allowlist. Kept as a separate endpoint so the legacy admin\'s GetAllGrid is left unchanged. (Auth roles: Catalog,OrderApproval,Erp)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [q]
         * @param {boolean} [searchVisible]
         * @param {string} [cids]
         * @param {boolean} [includeSubcategories]
         * @param {boolean} [includeMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGridV2(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGridV2(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAllGridV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProductAwardsById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProductAwardsById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAllProductAwardsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSubTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSubTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAllSubTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailabilityStatuses(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailabilityStatuses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAvailabilityStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailable(q, sort, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailable(q, sort, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [days]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBestSellers(days, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBestSellers(days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getBestSellers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [eagercache]
         * @param {boolean} [prefilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCategoryId(id, q, sort, page, psize, eagercache, prefilter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCategoryId(id, q, sort, page, psize, eagercache, prefilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByCategoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCode(code, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [customerId]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCustomerRecommendations(customerId, q, sort, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCustomerRecommendations(customerId, q, sort, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByCustomerRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIdEnriched(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIdEnriched(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByIdEnriched']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIdFront(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIdFront(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByIdFront']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, enrich, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, enrich, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIdsAdmin(request_body, enrich, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIdsAdmin(request_body, enrich, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByIdsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByManufacturerId(id, q, sort, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByManufacturerId(id, q, sort, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByManufacturerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [productsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByProductsIds(productsIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByProductsIds(productsIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByProductsIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [participatingProducts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByPromotionPolicyId(id, q, sort, page, psize, participatingProducts, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByPromotionPolicyId(id, q, sort, page, psize, participatingProducts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByPromotionPolicyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUrl(url, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUrl(url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getByUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [productId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryTree(productId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryTree(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getCategoryTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [codes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContributorProducts(id, sort, page, psize, codes, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContributorProducts(id, sort, page, psize, codes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getContributorProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscounted(q, sort, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscounted(q, sort, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getDiscounted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturedProducts(sort, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturedProducts(sort, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getFeaturedProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturedProductsByCategoryId(id, q, sort, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturedProductsByCategoryId(id, q, sort, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getFeaturedProductsByCategoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [statusId]
         * @param {string} [q]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiltersByCategoryAndStatusId(id, statusId, q, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiltersByCategoryAndStatusId(id, statusId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getFiltersByCategoryAndStatusId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [oid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFromSavedOrder(oid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFromSavedOrder(oid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getFromSavedOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiftCards(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiftCards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getGiftCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The products sharing the product\'s GroupCode, without the product itself: admin-v2 copies an editorial review onto them (BW-3930). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupedProducts(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupedProducts(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getGroupedProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewest(q, sort, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewest(q, sort, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getNewest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPerEntity(entityId, entity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPerEntity(entityId, entity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getPerEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {number} [numberOfItems]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonalisedProductsByCategory(categoryId, numberOfItems, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonalisedProductsByCategory(categoryId, numberOfItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getPersonalisedProductsByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [pdid]
         * @param {number} [tid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceHistory(id, pdid, tid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceHistory(id, pdid, tid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getPriceHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductBundleById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductBundleById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductBundleById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary All bundles containing the product that are active for the current customer, with enriched children and totals
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductBundles(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductBundles(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductBundles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [price]
         * @param {string} [priceBD]
         * @param {string} [discount]
         * @param {number} [dimensionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductLoyaltyPoints(id, price, priceBD, discount, dimensionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductLoyaltyPoints(id, price, priceBD, discount, dimensionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductLoyaltyPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {string} [price]
         * @param {string} [priceBD]
         * @param {string} [discount]
         * @param {number} [cid]
         * @param {number} [dimensionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductLoyaltyPointsAdmin(id, price, priceBD, discount, cid, dimensionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductLoyaltyPointsAdmin(id, price, priceBD, discount, cid, dimensionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductLoyaltyPointsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductStock(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductStock(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductType(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductType(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductWarehouses(code, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductWarehouses(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductWarehouses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsAwardsById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsAwardsById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductsAwardsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsByEventId(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsByEventId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductsByEventId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsByTopCustomerRecommendations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsByTopCustomerRecommendations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductsByTopCustomerRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [productId]
         * @param {string} [code]
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedInfoAndProductsByCode(productId, code, categoryId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedInfoAndProductsByCode(productId, code, categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getRelatedInfoAndProductsByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [productId]
         * @param {string} [code]
         * @param {number} [categoryId]
         * @param {Set<number>} [productCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedProductsByCode(productId, code, categoryId, productCategoryIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedProductsByCode(productId, code, categoryId, productCategoryIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getRelatedProductsByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [productId]
         * @param {number} [relationTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedProductsByProductId(productId, relationTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedProductsByProductId(productId, relationTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getRelatedProductsByProductId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchTerms(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSearchTerms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getSearchTerms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimpleLookup(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimpleLookup(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getSimpleLookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSizesByCategoryId(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSizesByCategoryId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getSizesByCategoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Per-status product counts for the grid saved-filter chips. Definitions mirror the legacy admin product filters (out-of-stock = grid Quantity <= 0; hidden = !IsVisible; featured; no-image = hasImage No; new-releases = ReleaseDate within the recent window). Reads over existing columns — no schema change. \"Pending ERP sync\" is omitted (no legacy definition). (Auth roles: Catalog, OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatusCounts(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatusCounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getStatusCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ProductToken} [ProductToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ProductToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ProductToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertProductAward(AwardToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertProductAward(AwardToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.insertProductAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Returns a list of products based on the provided filters. (Auth roles: Catalog, OrderApproval)
         * @param {ProductLookupRequest} ProductLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(ProductLookupRequest, X_Lookup_Metadata, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(ProductLookupRequest, X_Lookup_Metadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {PrerenderRecacheRequest} [PrerenderRecacheRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prerenderRecache(PrerenderRecacheRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prerenderRecache(PrerenderRecacheRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.prerenderRecache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [productId]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePerEntity(productId, entityId, entity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePerEntity(productId, entityId, entity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.removePerEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(q, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(q, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [key]
         * @param {string} [cids]
         * @param {string} [stids]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [prefilter]
         * @param {string} [code]
         * @param {string} [barcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchWithFilters(key, cids, stids, q, sort, page, psize, prefilter, code, barcode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchWithFilters(key, cids, stids, q, sort, page, psize, prefilter, code, barcode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.searchWithFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιστρέφει λίστα από διαθέσιμα product ids
         * @param {Array<number>} request_body Τα product ids που θέλουμε να δούμε αν είναι ορατά στο front
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trimProductIds(request_body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trimProductIds(request_body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.trimProductIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ProductToken} [ProductToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ProductToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ProductToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [productId]
         * @param {number} [sortIndex]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePerEntity(productId, sortIndex, entityId, entity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePerEntity(productId, sortIndex, entityId, entity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.updatePerEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductAward(AwardToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductAward(AwardToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.updateProductAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ProductsApi - factory interface
 * @export
 */
const ProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [Price]
         * @param {number} [DiscountRate]
         * @param {number} [DiscountValue]
         * @param {boolean} [Visible]
         * @param {boolean} [Used]
         * @param {boolean} [Featured]
         * @param {boolean} [Skroutz]
         * @param {boolean} [BestPrice]
         * @param {boolean} [Linkwise]
         * @param {boolean} [Social]
         * @param {number} [Availability]
         * @param {string} [CategoriesToAdd]
         * @param {string} [CategoriesToRemove]
         * @param {string} [ProductStatusesToAdd]
         * @param {string} [ProductStatusesToRemove]
         * @param {string} [VideoToAdd]
         * @param {string} [VideoToRemove]
         * @param {string} [NewsentryToAdd]
         * @param {string} [NewsentryToRemove]
         * @param {string} [EventsToAdd]
         * @param {string} [EventsToRemove]
         * @param {Array<number>} [CategoriesToAddList]
         * @param {Array<number>} [CategoriesToRemoveList]
         * @param {Array<number>} [ProductStatusesToAddList]
         * @param {Array<number>} [ProductStatusesToRemoveList]
         * @param {Array<number>} [VideoToAddList]
         * @param {Array<number>} [VideoToRemoveList]
         * @param {Array<number>} [NewsentryToAddList]
         * @param {Array<number>} [NewsentryToRemoveList]
         * @param {Array<number>} [EventsToAddList]
         * @param {Array<number>} [EventsToRemoveList]
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [productIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkEdit(Price, DiscountRate, DiscountValue, Visible, Used, Featured, Skroutz, BestPrice, Linkwise, Social, Availability, CategoriesToAdd, CategoriesToRemove, ProductStatusesToAdd, ProductStatusesToRemove, VideoToAdd, VideoToRemove, NewsentryToAdd, NewsentryToRemove, EventsToAdd, EventsToRemove, CategoriesToAddList, CategoriesToRemoveList, ProductStatusesToAddList, ProductStatusesToRemoveList, VideoToAddList, VideoToRemoveList, NewsentryToAddList, NewsentryToRemoveList, EventsToAddList, EventsToRemoveList, loadOptions, productIds, options) {
            return localVarFp.bulkEdit(Price, DiscountRate, DiscountValue, Visible, Used, Featured, Skroutz, BestPrice, Linkwise, Social, Availability, CategoriesToAdd, CategoriesToRemove, ProductStatusesToAdd, ProductStatusesToRemove, VideoToAdd, VideoToRemove, NewsentryToAdd, NewsentryToRemove, EventsToAdd, EventsToRemove, CategoriesToAddList, CategoriesToRemoveList, ProductStatusesToAddList, ProductStatusesToRemoveList, VideoToAddList, VideoToRemoveList, NewsentryToAddList, NewsentryToRemoveList, EventsToAddList, EventsToRemoveList, loadOptions, productIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {BulkEditTokenPost} [BulkEditTokenPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkEditPost(BulkEditTokenPost, options) {
            return localVarFp.bulkEditPost(BulkEditTokenPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categories(id, options) {
            return localVarFp.categories(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductAward(id, options) {
            return localVarFp.deleteProductAward(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary BW-8338 N4: the signed-in customer\'s catalogue as an Excel workbook, with their wholesale prices and the configured suggested-retail prices. 404 unless `CatalogExport:Enabled`, and 404 when the session resolves to no customer (e.g. the token of a removed employee) rather than exporting the anonymous catalogue. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCatalog(options) {
            return localVarFp.exportCatalog(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductTokenList} [ProductTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceERPSync(ProductTokenList, options) {
            return localVarFp.forceERPSync(ProductTokenList, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,OrderApproval,Erp)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [q]
         * @param {boolean} [searchVisible]
         * @param {string} [cids]
         * @param {boolean} [includeSubcategories]
         * @param {boolean} [includeMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGrid(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options) {
            return localVarFp.getAllGrid(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin-v2 products grid. Same shape/response as M:BizWeb.NC.API.Controllers.ProductsController.GetAllGrid(BizWeb.NC.API.DataSourceLoadOptions,BizWeb.NC.API.Services.IFileProcessor,System.String,System.Boolean,System.String,System.Boolean,System.Boolean), but applies server-side column sorting and free-text search to the SQL projection via an explicit allowlist. Kept as a separate endpoint so the legacy admin\'s GetAllGrid is left unchanged. (Auth roles: Catalog,OrderApproval,Erp)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {string} [q]
         * @param {boolean} [searchVisible]
         * @param {string} [cids]
         * @param {boolean} [includeSubcategories]
         * @param {boolean} [includeMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGridV2(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options) {
            return localVarFp.getAllGridV2(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductAwardsById(id, options) {
            return localVarFp.getAllProductAwardsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubTypes(options) {
            return localVarFp.getAllSubTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilityStatuses(options) {
            return localVarFp.getAvailabilityStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailable(q, sort, page, psize, options) {
            return localVarFp.getAvailable(q, sort, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [days]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestSellers(days, options) {
            return localVarFp.getBestSellers(days, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [eagercache]
         * @param {boolean} [prefilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCategoryId(id, q, sort, page, psize, eagercache, prefilter, options) {
            return localVarFp.getByCategoryId(id, q, sort, page, psize, eagercache, prefilter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCode(code, options) {
            return localVarFp.getByCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [customerId]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerRecommendations(customerId, q, sort, page, psize, options) {
            return localVarFp.getByCustomerRecommendations(customerId, q, sort, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdEnriched(id, options) {
            return localVarFp.getByIdEnriched(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdFront(id, options) {
            return localVarFp.getByIdFront(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, enrich, options) {
            return localVarFp.getByIds(request_body, enrich, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdsAdmin(request_body, enrich, options) {
            return localVarFp.getByIdsAdmin(request_body, enrich, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByManufacturerId(id, q, sort, page, psize, options) {
            return localVarFp.getByManufacturerId(id, q, sort, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [productsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByProductsIds(productsIds, options) {
            return localVarFp.getByProductsIds(productsIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [participatingProducts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPromotionPolicyId(id, q, sort, page, psize, participatingProducts, options) {
            return localVarFp.getByPromotionPolicyId(id, q, sort, page, psize, participatingProducts, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUrl(url, options) {
            return localVarFp.getByUrl(url, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [productId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryTree(productId, options) {
            return localVarFp.getCategoryTree(productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [codes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributorProducts(id, sort, page, psize, codes, options) {
            return localVarFp.getContributorProducts(id, sort, page, psize, codes, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscounted(q, sort, page, psize, options) {
            return localVarFp.getDiscounted(q, sort, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedProducts(sort, page, psize, options) {
            return localVarFp.getFeaturedProducts(sort, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedProductsByCategoryId(id, q, sort, page, psize, options) {
            return localVarFp.getFeaturedProductsByCategoryId(id, q, sort, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [statusId]
         * @param {string} [q]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltersByCategoryAndStatusId(id, statusId, q, options) {
            return localVarFp.getFiltersByCategoryAndStatusId(id, statusId, q, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [oid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFromSavedOrder(oid, options) {
            return localVarFp.getFromSavedOrder(oid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCards(options) {
            return localVarFp.getGiftCards(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The products sharing the product\'s GroupCode, without the product itself: admin-v2 copies an editorial review onto them (BW-3930). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupedProducts(id, options) {
            return localVarFp.getGroupedProducts(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewest(q, sort, page, psize, options) {
            return localVarFp.getNewest(q, sort, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerEntity(entityId, entity, options) {
            return localVarFp.getPerEntity(entityId, entity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {number} [numberOfItems]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalisedProductsByCategory(categoryId, numberOfItems, options) {
            return localVarFp.getPersonalisedProductsByCategory(categoryId, numberOfItems, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [pdid]
         * @param {number} [tid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceHistory(id, pdid, tid, options) {
            return localVarFp.getPriceHistory(id, pdid, tid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBundleById(id, options) {
            return localVarFp.getProductBundleById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary All bundles containing the product that are active for the current customer, with enriched children and totals
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBundles(id, options) {
            return localVarFp.getProductBundles(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [price]
         * @param {string} [priceBD]
         * @param {string} [discount]
         * @param {number} [dimensionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductLoyaltyPoints(id, price, priceBD, discount, dimensionId, options) {
            return localVarFp.getProductLoyaltyPoints(id, price, priceBD, discount, dimensionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {string} [price]
         * @param {string} [priceBD]
         * @param {string} [discount]
         * @param {number} [cid]
         * @param {number} [dimensionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductLoyaltyPointsAdmin(id, price, priceBD, discount, cid, dimensionId, options) {
            return localVarFp.getProductLoyaltyPointsAdmin(id, price, priceBD, discount, cid, dimensionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStock(id, options) {
            return localVarFp.getProductStock(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductType(options) {
            return localVarFp.getProductType(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarehouses(code, options) {
            return localVarFp.getProductWarehouses(code, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsAwardsById(id, options) {
            return localVarFp.getProductsAwardsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByEventId(id, options) {
            return localVarFp.getProductsByEventId(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByTopCustomerRecommendations(options) {
            return localVarFp.getProductsByTopCustomerRecommendations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [productId]
         * @param {string} [code]
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedInfoAndProductsByCode(productId, code, categoryId, options) {
            return localVarFp.getRelatedInfoAndProductsByCode(productId, code, categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [productId]
         * @param {string} [code]
         * @param {number} [categoryId]
         * @param {Set<number>} [productCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedProductsByCode(productId, code, categoryId, productCategoryIds, options) {
            return localVarFp.getRelatedProductsByCode(productId, code, categoryId, productCategoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [productId]
         * @param {number} [relationTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedProductsByProductId(productId, relationTypeId, options) {
            return localVarFp.getRelatedProductsByProductId(productId, relationTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchTerms(options) {
            return localVarFp.getSearchTerms(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleLookup(options) {
            return localVarFp.getSimpleLookup(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizesByCategoryId(id, options) {
            return localVarFp.getSizesByCategoryId(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Per-status product counts for the grid saved-filter chips. Definitions mirror the legacy admin product filters (out-of-stock = grid Quantity <= 0; hidden = !IsVisible; featured; no-image = hasImage No; new-releases = ReleaseDate within the recent window). Reads over existing columns — no schema change. \"Pending ERP sync\" is omitted (no legacy definition). (Auth roles: Catalog, OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusCounts(options) {
            return localVarFp.getStatusCounts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ProductToken} [ProductToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ProductToken, options) {
            return localVarFp.insert(ProductToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertProductAward(AwardToken, options) {
            return localVarFp.insertProductAward(AwardToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of products based on the provided filters. (Auth roles: Catalog, OrderApproval)
         * @param {ProductLookupRequest} ProductLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(ProductLookupRequest, X_Lookup_Metadata, options) {
            return localVarFp.lookup(ProductLookupRequest, X_Lookup_Metadata, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {PrerenderRecacheRequest} [PrerenderRecacheRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prerenderRecache(PrerenderRecacheRequest, options) {
            return localVarFp.prerenderRecache(PrerenderRecacheRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [productId]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePerEntity(productId, entityId, entity, options) {
            return localVarFp.removePerEntity(productId, entityId, entity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(q, page, psize, options) {
            return localVarFp.search(q, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [key]
         * @param {string} [cids]
         * @param {string} [stids]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [prefilter]
         * @param {string} [code]
         * @param {string} [barcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWithFilters(key, cids, stids, q, sort, page, psize, prefilter, code, barcode, options) {
            return localVarFp.searchWithFilters(key, cids, stids, q, sort, page, psize, prefilter, code, barcode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιστρέφει λίστα από διαθέσιμα product ids
         * @param {Array<number>} request_body Τα product ids που θέλουμε να δούμε αν είναι ορατά στο front
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trimProductIds(request_body, options) {
            return localVarFp.trimProductIds(request_body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,Erp)
         * @param {ProductToken} [ProductToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ProductToken, options) {
            return localVarFp.update(ProductToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [productId]
         * @param {number} [sortIndex]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerEntity(productId, sortIndex, entityId, entity, options) {
            return localVarFp.updatePerEntity(productId, sortIndex, entityId, entity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductAward(AwardToken, options) {
            return localVarFp.updateProductAward(AwardToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
class ProductsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [Price]
     * @param {number} [DiscountRate]
     * @param {number} [DiscountValue]
     * @param {boolean} [Visible]
     * @param {boolean} [Used]
     * @param {boolean} [Featured]
     * @param {boolean} [Skroutz]
     * @param {boolean} [BestPrice]
     * @param {boolean} [Linkwise]
     * @param {boolean} [Social]
     * @param {number} [Availability]
     * @param {string} [CategoriesToAdd]
     * @param {string} [CategoriesToRemove]
     * @param {string} [ProductStatusesToAdd]
     * @param {string} [ProductStatusesToRemove]
     * @param {string} [VideoToAdd]
     * @param {string} [VideoToRemove]
     * @param {string} [NewsentryToAdd]
     * @param {string} [NewsentryToRemove]
     * @param {string} [EventsToAdd]
     * @param {string} [EventsToRemove]
     * @param {Array<number>} [CategoriesToAddList]
     * @param {Array<number>} [CategoriesToRemoveList]
     * @param {Array<number>} [ProductStatusesToAddList]
     * @param {Array<number>} [ProductStatusesToRemoveList]
     * @param {Array<number>} [VideoToAddList]
     * @param {Array<number>} [VideoToRemoveList]
     * @param {Array<number>} [NewsentryToAddList]
     * @param {Array<number>} [NewsentryToRemoveList]
     * @param {Array<number>} [EventsToAddList]
     * @param {Array<number>} [EventsToRemoveList]
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {string} [productIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    bulkEdit(Price, DiscountRate, DiscountValue, Visible, Used, Featured, Skroutz, BestPrice, Linkwise, Social, Availability, CategoriesToAdd, CategoriesToRemove, ProductStatusesToAdd, ProductStatusesToRemove, VideoToAdd, VideoToRemove, NewsentryToAdd, NewsentryToRemove, EventsToAdd, EventsToRemove, CategoriesToAddList, CategoriesToRemoveList, ProductStatusesToAddList, ProductStatusesToRemoveList, VideoToAddList, VideoToRemoveList, NewsentryToAddList, NewsentryToRemoveList, EventsToAddList, EventsToRemoveList, loadOptions, productIds, options) {
        return ProductsApiFp(this.configuration).bulkEdit(Price, DiscountRate, DiscountValue, Visible, Used, Featured, Skroutz, BestPrice, Linkwise, Social, Availability, CategoriesToAdd, CategoriesToRemove, ProductStatusesToAdd, ProductStatusesToRemove, VideoToAdd, VideoToRemove, NewsentryToAdd, NewsentryToRemove, EventsToAdd, EventsToRemove, CategoriesToAddList, CategoriesToRemoveList, ProductStatusesToAddList, ProductStatusesToRemoveList, VideoToAddList, VideoToRemoveList, NewsentryToAddList, NewsentryToRemoveList, EventsToAddList, EventsToRemoveList, loadOptions, productIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {BulkEditTokenPost} [BulkEditTokenPost]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    bulkEditPost(BulkEditTokenPost, options) {
        return ProductsApiFp(this.configuration).bulkEditPost(BulkEditTokenPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    categories(id, options) {
        return ProductsApiFp(this.configuration).categories(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    deleteProductAward(id, options) {
        return ProductsApiFp(this.configuration).deleteProductAward(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary BW-8338 N4: the signed-in customer\'s catalogue as an Excel workbook, with their wholesale prices and the configured suggested-retail prices. 404 unless `CatalogExport:Enabled`, and 404 when the session resolves to no customer (e.g. the token of a removed employee) rather than exporting the anonymous catalogue. (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    exportCatalog(options) {
        return ProductsApiFp(this.configuration).exportCatalog(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductTokenList} [ProductTokenList]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    forceERPSync(ProductTokenList, options) {
        return ProductsApiFp(this.configuration).forceERPSync(ProductTokenList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getAll(options) {
        return ProductsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,OrderApproval,Erp)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {string} [q]
     * @param {boolean} [searchVisible]
     * @param {string} [cids]
     * @param {boolean} [includeSubcategories]
     * @param {boolean} [includeMetadata]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getAllGrid(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options) {
        return ProductsApiFp(this.configuration).getAllGrid(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin-v2 products grid. Same shape/response as M:BizWeb.NC.API.Controllers.ProductsController.GetAllGrid(BizWeb.NC.API.DataSourceLoadOptions,BizWeb.NC.API.Services.IFileProcessor,System.String,System.Boolean,System.String,System.Boolean,System.Boolean), but applies server-side column sorting and free-text search to the SQL projection via an explicit allowlist. Kept as a separate endpoint so the legacy admin\'s GetAllGrid is left unchanged. (Auth roles: Catalog,OrderApproval,Erp)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {string} [q]
     * @param {boolean} [searchVisible]
     * @param {string} [cids]
     * @param {boolean} [includeSubcategories]
     * @param {boolean} [includeMetadata]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getAllGridV2(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options) {
        return ProductsApiFp(this.configuration).getAllGridV2(loadOptions, q, searchVisible, cids, includeSubcategories, includeMetadata, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getAllProductAwardsById(id, options) {
        return ProductsApiFp(this.configuration).getAllProductAwardsById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getAllSubTypes(options) {
        return ProductsApiFp(this.configuration).getAllSubTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getAvailabilityStatuses(options) {
        return ProductsApiFp(this.configuration).getAvailabilityStatuses(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getAvailable(q, sort, page, psize, options) {
        return ProductsApiFp(this.configuration).getAvailable(q, sort, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [days]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getBestSellers(days, options) {
        return ProductsApiFp(this.configuration).getBestSellers(days, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {boolean} [eagercache]
     * @param {boolean} [prefilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByCategoryId(id, q, sort, page, psize, eagercache, prefilter, options) {
        return ProductsApiFp(this.configuration).getByCategoryId(id, q, sort, page, psize, eagercache, prefilter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {string} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByCode(code, options) {
        return ProductsApiFp(this.configuration).getByCode(code, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [customerId]
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByCustomerRecommendations(customerId, q, sort, page, psize, options) {
        return ProductsApiFp(this.configuration).getByCustomerRecommendations(customerId, q, sort, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getById(id, options) {
        return ProductsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByIdEnriched(id, options) {
        return ProductsApiFp(this.configuration).getByIdEnriched(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByIdFront(id, options) {
        return ProductsApiFp(this.configuration).getByIdFront(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} [request_body]
     * @param {boolean} [enrich]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByIds(request_body, enrich, options) {
        return ProductsApiFp(this.configuration).getByIds(request_body, enrich, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {Array<number>} [request_body]
     * @param {boolean} [enrich]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByIdsAdmin(request_body, enrich, options) {
        return ProductsApiFp(this.configuration).getByIdsAdmin(request_body, enrich, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByManufacturerId(id, q, sort, page, psize, options) {
        return ProductsApiFp(this.configuration).getByManufacturerId(id, q, sort, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [productsIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByProductsIds(productsIds, options) {
        return ProductsApiFp(this.configuration).getByProductsIds(productsIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {boolean} [participatingProducts]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByPromotionPolicyId(id, q, sort, page, psize, participatingProducts, options) {
        return ProductsApiFp(this.configuration).getByPromotionPolicyId(id, q, sort, page, psize, participatingProducts, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getByUrl(url, options) {
        return ProductsApiFp(this.configuration).getByUrl(url, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [productId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getCategoryTree(productId, options) {
        return ProductsApiFp(this.configuration).getCategoryTree(productId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {string} [codes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getContributorProducts(id, sort, page, psize, codes, options) {
        return ProductsApiFp(this.configuration).getContributorProducts(id, sort, page, psize, codes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getDiscounted(q, sort, page, psize, options) {
        return ProductsApiFp(this.configuration).getDiscounted(q, sort, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getFeaturedProducts(sort, page, psize, options) {
        return ProductsApiFp(this.configuration).getFeaturedProducts(sort, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getFeaturedProductsByCategoryId(id, q, sort, page, psize, options) {
        return ProductsApiFp(this.configuration).getFeaturedProductsByCategoryId(id, q, sort, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {number} [statusId]
     * @param {string} [q]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getFiltersByCategoryAndStatusId(id, statusId, q, options) {
        return ProductsApiFp(this.configuration).getFiltersByCategoryAndStatusId(id, statusId, q, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [oid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getFromSavedOrder(oid, options) {
        return ProductsApiFp(this.configuration).getFromSavedOrder(oid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getGiftCards(options) {
        return ProductsApiFp(this.configuration).getGiftCards(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The products sharing the product\'s GroupCode, without the product itself: admin-v2 copies an editorial review onto them (BW-3930). (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getGroupedProducts(id, options) {
        return ProductsApiFp(this.configuration).getGroupedProducts(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getNewest(q, sort, page, psize, options) {
        return ProductsApiFp(this.configuration).getNewest(q, sort, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [entityId]
     * @param {string} [entity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getPerEntity(entityId, entity, options) {
        return ProductsApiFp(this.configuration).getPerEntity(entityId, entity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [categoryId]
     * @param {number} [numberOfItems]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getPersonalisedProductsByCategory(categoryId, numberOfItems, options) {
        return ProductsApiFp(this.configuration).getPersonalisedProductsByCategory(categoryId, numberOfItems, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {number} [pdid]
     * @param {number} [tid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getPriceHistory(id, pdid, tid, options) {
        return ProductsApiFp(this.configuration).getPriceHistory(id, pdid, tid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductBundleById(id, options) {
        return ProductsApiFp(this.configuration).getProductBundleById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary All bundles containing the product that are active for the current customer, with enriched children and totals
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductBundles(id, options) {
        return ProductsApiFp(this.configuration).getProductBundles(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [price]
     * @param {string} [priceBD]
     * @param {string} [discount]
     * @param {number} [dimensionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductLoyaltyPoints(id, price, priceBD, discount, dimensionId, options) {
        return ProductsApiFp(this.configuration).getProductLoyaltyPoints(id, price, priceBD, discount, dimensionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {number} [id]
     * @param {string} [price]
     * @param {string} [priceBD]
     * @param {string} [discount]
     * @param {number} [cid]
     * @param {number} [dimensionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductLoyaltyPointsAdmin(id, price, priceBD, discount, cid, dimensionId, options) {
        return ProductsApiFp(this.configuration).getProductLoyaltyPointsAdmin(id, price, priceBD, discount, cid, dimensionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductStock(id, options) {
        return ProductsApiFp(this.configuration).getProductStock(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductType(options) {
        return ProductsApiFp(this.configuration).getProductType(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductWarehouses(code, options) {
        return ProductsApiFp(this.configuration).getProductWarehouses(code, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductsAwardsById(id, options) {
        return ProductsApiFp(this.configuration).getProductsAwardsById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductsByEventId(id, options) {
        return ProductsApiFp(this.configuration).getProductsByEventId(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProductsByTopCustomerRecommendations(options) {
        return ProductsApiFp(this.configuration).getProductsByTopCustomerRecommendations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [productId]
     * @param {string} [code]
     * @param {number} [categoryId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getRelatedInfoAndProductsByCode(productId, code, categoryId, options) {
        return ProductsApiFp(this.configuration).getRelatedInfoAndProductsByCode(productId, code, categoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [productId]
     * @param {string} [code]
     * @param {number} [categoryId]
     * @param {Set<number>} [productCategoryIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getRelatedProductsByCode(productId, code, categoryId, productCategoryIds, options) {
        return ProductsApiFp(this.configuration).getRelatedProductsByCode(productId, code, categoryId, productCategoryIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [productId]
     * @param {number} [relationTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getRelatedProductsByProductId(productId, relationTypeId, options) {
        return ProductsApiFp(this.configuration).getRelatedProductsByProductId(productId, relationTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getSearchTerms(options) {
        return ProductsApiFp(this.configuration).getSearchTerms(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getSimpleLookup(options) {
        return ProductsApiFp(this.configuration).getSimpleLookup(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getSizesByCategoryId(id, options) {
        return ProductsApiFp(this.configuration).getSizesByCategoryId(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Per-status product counts for the grid saved-filter chips. Definitions mirror the legacy admin product filters (out-of-stock = grid Quantity <= 0; hidden = !IsVisible; featured; no-image = hasImage No; new-releases = ReleaseDate within the recent window). Reads over existing columns — no schema change. \"Pending ERP sync\" is omitted (no legacy definition). (Auth roles: Catalog, OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getStatusCounts(options) {
        return ProductsApiFp(this.configuration).getStatusCounts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,Erp)
     * @param {ProductToken} [ProductToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    insert(ProductToken, options) {
        return ProductsApiFp(this.configuration).insert(ProductToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {AwardToken} [AwardToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    insertProductAward(AwardToken, options) {
        return ProductsApiFp(this.configuration).insertProductAward(AwardToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of products based on the provided filters. (Auth roles: Catalog, OrderApproval)
     * @param {ProductLookupRequest} ProductLookupRequest
     * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    lookup(ProductLookupRequest, X_Lookup_Metadata, options) {
        return ProductsApiFp(this.configuration).lookup(ProductLookupRequest, X_Lookup_Metadata, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {PrerenderRecacheRequest} [PrerenderRecacheRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    prerenderRecache(PrerenderRecacheRequest, options) {
        return ProductsApiFp(this.configuration).prerenderRecache(PrerenderRecacheRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,Erp)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    remove(id, options) {
        return ProductsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [productId]
     * @param {number} [entityId]
     * @param {string} [entity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    removePerEntity(productId, entityId, entity, options) {
        return ProductsApiFp(this.configuration).removePerEntity(productId, entityId, entity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [q]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    search(q, page, psize, options) {
        return ProductsApiFp(this.configuration).search(q, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [key]
     * @param {string} [cids]
     * @param {string} [stids]
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {boolean} [prefilter]
     * @param {string} [code]
     * @param {string} [barcode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    searchWithFilters(key, cids, stids, q, sort, page, psize, prefilter, code, barcode, options) {
        return ProductsApiFp(this.configuration).searchWithFilters(key, cids, stids, q, sort, page, psize, prefilter, code, barcode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιστρέφει λίστα από διαθέσιμα product ids
     * @param {Array<number>} request_body Τα product ids που θέλουμε να δούμε αν είναι ορατά στο front
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    trimProductIds(request_body, options) {
        return ProductsApiFp(this.configuration).trimProductIds(request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,Erp)
     * @param {ProductToken} [ProductToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    update(ProductToken, options) {
        return ProductsApiFp(this.configuration).update(ProductToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [productId]
     * @param {number} [sortIndex]
     * @param {number} [entityId]
     * @param {string} [entity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    updatePerEntity(productId, sortIndex, entityId, entity, options) {
        return ProductsApiFp(this.configuration).updatePerEntity(productId, sortIndex, entityId, entity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {AwardToken} [AwardToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    updateProductAward(AwardToken, options) {
        return ProductsApiFp(this.configuration).updateProductAward(AwardToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ProductsApi, ProductsApiAxiosParamCreator, ProductsApiFactory, ProductsApiFp };
//# sourceMappingURL=products-api.js.map
